/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {useState, useEffect} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../../store/store';
import Finances from '../../../widgets/Finances';
import Carousel from '../../../shared/Carousel';
import posterImg from '../../../../_metronic/assets/media/bonus.png';
import {Button} from '../../../shared/Buttons';
import Card from '../../../shared/Card';
import PageWrapper from '../../../modules/PageWrapper';
import {Link} from 'react-router-dom';
import {findKPIRd} from '../../../functions/findKPI';
import {formatNumberToCash, formatNumber, formatNumber2} from '../../../functions/formatNumber';

const addThousands = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const normalizeNumericString = (value) => {
  if (value === null || value === undefined) return '0';
  let s = String(value).trim();

  // убираем валюту/пробелы, оставляем цифры, -, . , 
  s = s.replace(/\s+/g, '').replace(/[^0-9.,-]/g, '');

  // если есть и ',' и '.', считаем что ',' это тысячи -> убираем ','
  if (s.includes(',') && s.includes('.')) {
    s = s.replace(/,/g, '');
  } else {
    // если только ',', считаем что это десятичный разделитель
    s = s.replace(',', '.');
  }

  // если пусто или просто '-', вернем 0
  if (s === '' || s === '-') return '0';

  return s;
};

export const formatMoneyTruncate = (value) => {
  let s = normalizeNumericString(value);

  const isNeg = s.startsWith('-');
  if (isNeg) s = s.slice(1);

  let [intPart, fracPart = ''] = s.split('.');
  intPart = intPart.replace(/^0+(?=\d)/, ''); // убираем ведущие нули (кроме "0")

  fracPart = fracPart.slice(0, 2).padEnd(2, '0');

  const formattedInt = addThousands(intPart === '' ? '0' : intPart);
  return `${isNeg ? '-' : ''}${formattedInt}.${fracPart}$`;
};

export const formatMoneyNoDecimals = (value) => {
  let s = normalizeNumericString(value);

  const isNeg = s.startsWith('-');
  if (isNeg) s = s.slice(1);

  let intPart = s.split('.')[0];
  intPart = intPart.replace(/^0+(?=\d)/, '');

  const formattedInt = addThousands(intPart === '' ? '0' : intPart);
  return `${isNeg ? '-' : ''}${formattedInt}$`;
};




const DashboardPage = observer(({timeConfig, isVerify, setPreloader}) => {
  const store = useStore();

  const [salesStats, setSalesStats] = useState({});
  const [rdStats, setRdStats] = useState();
  const [forecast, setForecast] = useState();

  useEffect(() => {
    isVerify && timeConfig.time_config && getData();
  }, [isVerify, timeConfig]);

  const getData = async () => {
    const getSalesStats = await store.requestGet(`user/sales/rd/manager/statistics`, {
      params: timeConfig,
    });
    const getRdStats = await store.requestGet(`Dashboard/Sales/Rd/Manager/getRdStats`, {
      params: timeConfig,
    });
    const getForecast = await store.requestGet(`Dashboard/Sales/Rd/Manager/getForecastPayout`);

    const rdList = await store.requestGet(`Sales/getKpiRdList`);

    setForecast(getForecast);
    setRdStats({
      ...getRdStats,
      indicator: findKPIRd(
        rdList,
        getRdStats?.count_qualifications,
        getRdStats?.activity,
        getRdStats?.rd,
        'manager_kpi'
      ),
    });
    setSalesStats(getSalesStats);
    setPreloader(false);
  };

  return (
    <>
      <div className='row g-5 g-xl-10 mt-0'>
        <div className='col-xl-4 mb-xl-10 mt-0'>
          <Finances
            background={'bg_rd_manager'}
            title='Статистика'
            subTitle='Управляйте периодом в календаре.'
            stats={[
              {
                title: 'Квалификации',
                number: formatNumber(salesStats?.qualifications_count) || 0,
                icon: (
                  <i className='ki-duotone ki-fingerprint-scanning fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                    <span className='path5'></span>
                  </i>
                ),
              },
              {
                title: 'Депозиты',
                number: formatNumber(salesStats?.deposits_count) || 0,
                icon: (
                  <i className='ki-duotone ki-wallet fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                ),
              },
              {
                title: 'Сумма депозитов',
                number: formatMoneyNoDecimals(salesStats?.deposits_amount),
                icon: (
                  <i className='ki-duotone ki-dollar fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
              {
                title: 'Средний чек',
               number: formatMoneyTruncate(salesStats?.players_avg_amount),
                icon: (
                  <i className='ki-duotone ki-user-tick fs-1 text-primary'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                ),
              },
            ]}
          />
        </div>

        <div className='col-xl-8 mb-5 mb-xl-10 mt-xl-0'>
            {/*<div className='row g-5 g-xl-10'>
            <div className='col-xl-6 mb-xl-10'>
              <Carousel title={'RD'} subTitle={'Tекущие KPI'}>
                <div className={`carousel-item`}>
                  <div className='d-flex align-items-center mb-5'>
                    <div className='w-80px flex-shrink-0 me-2 symbol symbol-70px symbol-circle me-5'>
                      <span
                        className={`symbol-label bg-light-${rdStats?.indicator?.indicator} w-70`}
                      >
                        <i
                          className={`ki-duotone ki-abstract-24 fs-3x text-${rdStats?.indicator?.indicator}`}
                        >
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </span>
                    </div>

                    <div className='m-0'>
                      <h4 className='fw-bold text-gray-800 mb-3'>
                        {rdStats?.rd}$
                        <span
                          className={`badge badge-light-${rdStats?.indicator?.indicator} fs-5 fw-bold`}
                        >
                          {rdStats?.indicator?.indicator === 'danger' && 'Плохой результат'}
                          {rdStats?.indicator?.indicator === 'warning' && 'Средний результат'}
                          {rdStats?.indicator?.indicator === 'success' && 'Хороший результат'}
                        </span>
                      </h4>
                      <div className='d-flex d-grid gap-5'>
                        <div className='d-flex flex-column flex-shrink-0 me-4'>
                          <span className='d-flex align-items-center fs-7 fw-bold text-gray-400 mb-2'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Активность: {formatNumber2(rdStats?.activity)}%
                          </span>

                          <span className='d-flex align-items-center text-gray-400 fw-bold fs-7'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Сумма депозитов: {formatNumberToCash(rdStats?.amounts_deposits)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Link to={`/sales/rd/kpi`}>
                    <Button color={'btn-primary'}>Подробнее</Button>
                  </Link>
                </div>
              </Carousel>
            </div>

           <div className='col-xl-6 mb-5 mb-xl-10' >
              <Carousel title={'Прогноз'} subTitle={'Прогноз выплаты за текущий период'}>
                <div className={`carousel-item active`} >
                  <div className='d-flex align-items-center mb-5'>
                    <div className='w-80px flex-shrink-0 me-2 symbol symbol-70px symbol-circle me-5'>
                      <span className={`symbol-label bg-light-primary w-70`}>
                        <i className={`ki-duotone ki-abstract-24 fs-3x text-primary`}>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </span>
                    </div>

                    <div className='m-0'>
                      <h4 className='fw-bold text-gray-800 mb-3'>
                        {formatNumberToCash(forecast?.payout)}
                      </h4>

                      <div className='d-flex d-grid gap-5'>
                        <div className='d-flex flex-column flex-shrink-0 me-4'>
                          <span className='d-flex align-items-center fs-7 fw-bold text-gray-400 mb-2'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Сумма депозитов: {formatNumberToCash(forecast?.amounts_deposits)}
                          </span>

                          <span className='d-flex align-items-center text-gray-400 fw-bold fs-7'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Активность: {formatNumber2(rdStats?.activity)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Link to={`/sales/rd/top/managers`}>
                    <Button color={'btn-primary'}>Подробнее</Button>
                  </Link>
                </div>
              </Carousel>
            </div>*/}


            {/*<div className='col-xl-6 mb-5 mb-xl-10'>
              <Carousel title={'Прогноз'} subTitle={'Прогноз выплаты за текущий период'}>
                <div className={`carousel-item active`}>
                  <div className='d-flex align-items-center mb-5'>
                    <div className='w-80px flex-shrink-0 me-2 symbol symbol-70px symbol-circle me-5'>
                      <span className={`symbol-label bg-light-primary w-70`}>
                        <i className={`ki-duotone ki-abstract-24 fs-3x text-primary`}>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </span>
                    </div>

                    <div className='m-0'>
                      <h4 className='fw-bold text-gray-800 mb-3'>
                        {formatNumberToCash(forecast?.payout)}
                      </h4>

                      <div className='d-flex d-grid gap-5'>
                        <div className='d-flex flex-column flex-shrink-0 me-4'>
                          <span className='d-flex align-items-center fs-7 fw-bold text-gray-400 mb-2'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Сумма депозитов: {formatNumberToCash(forecast?.amounts_deposits)}
                          </span>

                          <span className='d-flex align-items-center text-gray-400 fw-bold fs-7'>
                            <i className='ki-duotone ki-right-square fs-6 text-gray-600 me-2'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            Активность: {formatNumber2(rdStats?.activity)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Link to={`/sales/rd/top/managers`}>
                    <Button color={'btn-primary'}>Подробнее</Button>
                  </Link>
                </div>
              </Carousel>
            </div>
          </div>*/}

          <Card className='card' data-bs-theme='light' style={{
            background: 'radial-gradient(1200px 800px at 50% 35%, #2a2f42 0%, #12131a 40%, #07070a 100%)'
          }}>
            <div className='card-body d-flex ps-xl-15'>
              <div className='m-0'>
                <div className='position-relative fs-2x z-index-2 fw-bold text-white mb-7'>
                  <span className='me-2'>
                    Приведи менеджера и получи{' '}
                    <span className='position-relative d-inline-block text-danger'>
                      <span className='text-danger opacity-75-hover'>100$</span>

                      <span className='position-absolute opacity-50 bottom-0 start-0 border-4 border-danger border-bottom w-100'></span>
                    </span>
                  </span>
                  за каждого.
                  <br /> Условия по кнопке ниже!
                </div>
                <a
                  href='https://t.me/priority0000'
                  target='_blank'
                  className='btn fw-bold  btn-danger cursor-pointer'
                  rel='noreferrer'
                >
                  Подробнее
                </a>
              </div>

              <img
                src={posterImg}
                className='position-absolute me-3 bottom-0 end-0 h-200px'
                alt=''
              />
            </div>
          </Card>
        </div>
        {/* <div className='col-xl-12 mb-5 mb-xl-10 mt-0'>
          <Chart data={{graph: qualificationSchedule}} />
        </div> */}
      </div>
    </>
  );
});

const ManagerRD = () => {
  return (
    <PageWrapper
      firstTimeConfig='current_week'
      mode='sales'
      breadcrumbs={[
        {title: 'Panel', path: ''},
        {isSeparator: true},
        {title: 'Панель', path: '/dashboard/manager/rd', isActive: true},
      ]}
      title={'Панель'}
    >
      <DashboardPage />
    </PageWrapper>
  );
};

export default ManagerRD;
